import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

const REDIRECT_KEY = 'auth-redirect-state';

export interface RedirectState {
  redirect?: string;
  returnUrl?: string;
  origin?: string;
}

@Injectable({
  providedIn: 'root'
})
export class RedirectStateService {
  private state: RedirectState | null = null;

  constructor(private storageService: StorageService) {}

  set(state: RedirectState) {
    if (!state) {
      this.clear();
      return;
    }

    const merged: RedirectState = {
      ...(this.state ?? {}),
      ...state
    };

    const hasValue = !!(merged.redirect || merged.returnUrl || merged.origin);
    if (!hasValue) {
      this.clear();
      return;
    }

    this.state = merged;
    this.storageService.set(REDIRECT_KEY, merged, false);
  }

  get(): RedirectState {
    if (this.state) {
      return this.state;
    }

    const cached = this.storageService.get(REDIRECT_KEY);
    if (!cached) {
      return {};
    }

    try {
      this.state = JSON.parse(cached) as RedirectState;
      return this.state ?? {};
    } catch {
      this.storageService.delete(REDIRECT_KEY);
      this.state = null;
      return {};
    }
  }

  clear() {
    this.state = null;
    this.storageService.delete(REDIRECT_KEY);
  }
}
